import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService, ConfigurationService, DataClientError, LoginType} from "@fedeltapointofsale/data-client";
import {ErrorHandlerService} from "../../error-handler.service";
import {WhoAmI} from "../../config";

@Component({
    selector: "wbo-fedelta-support-login-page",
    templateUrl: "./fedelta-support-login-page.component.html",
    styleUrls: ["./fedelta-support-login-page.component.scss"]
})
export class FedeltaSupportLoginPageComponent implements OnInit {

    constructor(private router: Router,
                private errorHandlerService: ErrorHandlerService,
                private authService: AuthService,
                private configService: ConfigurationService,
                private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.loginWithToken();
    }

    loginWithToken(): void {
        this.route.paramMap.subscribe(params => {
            const token: string = params.get("token");

            this.authService.login("fedelta-support-token", token, LoginType.USER, {remember: false})
                .subscribe({
                    next: (success: boolean) => {
                        if (success) {
                            this.loggedIn();
                        } else {
                            this.errorHandlerService.displayError("wbo.login.error.failed");
                        }
                    },
                    error: async (error: DataClientError) => {
                        const displayableMessage = await (error.displayableMessage);
                        if (error.status === 401 && displayableMessage) {
                            this.errorHandlerService.displayError(displayableMessage.messageKey, displayableMessage.messageParams);
                        } else if (error.status === 404) {
                            this.errorHandlerService.displayError("wbo.common.error.noService");
                        } else {
                            this.errorHandlerService.displayError("wbo.common.error.noConnection");
                        }
                    }
                });


        });
    }


    loggedIn(): void {
        console.log("Logged in as: " + this.authService.getLoggedInUserName());
        this.configService.setContext("userId", this.authService.getLoggedInUserId().toString());
        this.configService.setContext("role", this.authService.getLoggedInRole());
        if (this.authService.getLoggedInUserName() === "Chewzie-Scan") {
            WhoAmI.beaconScanOnly = true;
            this.router.navigate(["/main/web-ordering-beacon/new"]);
        } else {
            this.router.navigate([""]);
        }
    }
}
